import { render, staticRenderFns } from "./serviceOrder.vue?vue&type=template&id=124f11ae&scoped=true&"
import script from "./serviceOrder.vue?vue&type=script&lang=js&"
export * from "./serviceOrder.vue?vue&type=script&lang=js&"
import style0 from "./serviceOrder.vue?vue&type=style&index=0&id=124f11ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124f11ae",
  null
  
)

export default component.exports